import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=1bb57f74&"
import script from "./FormRadio.vue?vue&type=script&lang=js&"
export * from "./FormRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
